import { render, staticRenderFns } from "./AlisIrsaliyeView.vue?vue&type=template&id=3aa5fd9c&"
import script from "./AlisIrsaliyeView.vue?vue&type=script&lang=js&"
export * from "./AlisIrsaliyeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports